import React from 'react';
import { Text, Button } from 'ui';
import moment from 'moment';
import countries from 'config/countries.js';
import { pink } from 'config/colors';

export default function(props) {
  let countriesString = "";
  let regionsString = "";
  let statesString = "";
  
  // Pull countries.
  
  if(props.campaign.country) {
    const countryData = props.campaign.country
      .split(',')
      .map(v => v.trim())
      .map(v => countries.find(c => c.value === v))
      .filter(v => !!v);
      
    const regions = countryData
      .reduce((regions, country) => {
        return [...regions, ...(country.regions || [])];
      }, []);
    const regionData = props.campaign.region
      .split(',')
      .map(v => v.trim())
      .map(v => regions.find(r => r.value === v))
      .filter(v => !!v);
    
    const states = countryData.reduce((states, country) => {
      return [...states, ...(country.states || [])];
    }, []);
    const stateData = props.campaign.state
      .split(',')
      .map(v => v.trim())
      .map(v => states.find(s => s.value === v))
      .filter(v => !!v);
    
    countriesString = countryData.map(c => c.label).join(', ');
    regionsString = regionData.map(c => c.label).join(', ');
    statesString = stateData.map(c => c.label).join(', ');
  }
  
  
  
  return (
    <div style={{display:'flex', flexDirection:'row', alignItems:'flex-start', paddingBottom:24}}>
      <div style={{flex:1}} className="campaignview-info-meta">
        <Text block>
          <Text small style={{display:'inline-block', width:100}}>Dates</Text>
          <Text>{moment(props.campaign.start).format("MM/DD/YYYY")} - {moment(props.campaign.end).format("MM/DD/YYYY")}</Text>
        </Text>
        
        {countriesString && 
          <Text block>
            <Text small style={{display:'inline-block', width:100}}>Country</Text>
            <Text>{countriesString}</Text>
          </Text>
        }
        {regionsString && 
          <Text block>
            <Text small style={{display:'inline-block', width:100}}>Region</Text>
            <Text>{regionsString}</Text>
          </Text>
        } 
        {statesString && 
          <Text block>
            <Text small style={{display:'inline-block', width:100}}>State</Text>
            <Text>{statesString}</Text>
          </Text>
        }
        
        <Text block>
          <Text small style={{display:'inline-block', width:100}}>URL</Text>
          <Text color={pink}>
            <a href={`${window.location.origin}/#${props.campaign.slug}`} target="_blank" rel="noopener noreferrer">
              https://tap.page/#{props.campaign.slug}
            </a>
          </Text>
        </Text>
        
        {props.campaign.dateModified && 
          <Text block>
            <Text small style={{display:'inline-block', width:100}}>Updated</Text>
            <Text>{moment(props.campaign.dateModified).format("MM/DD/YYYY h:mma")}</Text>
          </Text>
        }
        
        {props.campaign.datePublished && 
          <Text block>
            <Text small style={{display:'inline-block', width:100}}>Published</Text>
            <Text>{moment(props.campaign.datePublished).format("MM/DD/YYYY h:mma")}</Text>
          </Text>
        }
          
      </div>
      <div style={{marginLeft:80}}>
        <Button 
          label="Edit" 
          style={{backgroundColor:'#e3e5e4', marginBottom:24}}
          onClick={props.onEdit}
        />
      </div>
    </div>
  );
}